import React from 'react';
import styled from '@emotion/styled';
import ReactMarkdown from 'react-markdown';
import { Grid, TextEnterExit } from 'style';

const TextComponent = ({ text }) => (
    <Grid.Container id="textComponent">
        <Grid.Row>
            <Text>
                <ReactMarkdown
                    source={text}
                    containerTagName="div"
                    className="markdown"
                    renderers={{ root: 'div' }}
                />
            </Text>
        </Grid.Row>
    </Grid.Container>
);

const Text = styled.div`
    margin-left: 40%;
    padding: 100px 0;

    ${TextEnterExit};
`;

export default TextComponent;
